import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './FaqV2.css';

const cx = classnames.bind(styles);

const FAQ_ITEMS = [
    {
        question: 'What if I don’t remember much?',
        answer: 'Most people are surprised. One specific question brings back more than you’d expect - and you can start with what you remember best.'
    },
    {
        question: 'I’m not a writer. Can I still do this?',
        answer: 'Yes. You can simply talk. We turn what you say into a written story you can read and change.'
    },
    {
        question: 'Is it hard to use on my phone?',
        answer: 'No. We ask one question at a time, and you answer out loud or by typing. Nothing else to learn.'
    },
    {
        question: 'Who can see my stories?',
        answer: 'Only you, unless you choose to share them.'
    },
    {
        question: 'What happens to my stories if I cancel?',
        answer: 'The stories you’ve finished stay yours to keep.'
    },
    {
        question: 'How do I cancel?',
        answer: 'Anytime, in a couple of taps from your profile.'
    }
];

function FaqV2({ heading = 'People often ask', items = FAQ_ITEMS }) {
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <div className={styles.root}>
            <h2 className={styles.heading}>{heading}</h2>
            <ul className={styles.list}>
                {items.map((item, index) => {
                    const isOpen = index === openIndex;

                    return (
                        <li key={item.question} className={styles.item}>
                            <button
                                type='button'
                                className={styles.question}
                                onClick={() => setOpenIndex(isOpen ? null : index)}
                                aria-expanded={isOpen}
                            >
                                <span>{item.question}</span>
                                <Icon name='chevronDown' className={cx('chevronIcon', { isOpen })} />
                            </button>
                            {isOpen && <p className={styles.answer}>{item.answer}</p>}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

FaqV2.propTypes = {
    heading: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({ question: PropTypes.string, answer: PropTypes.string }))
};

export {
    FaqV2
};
